<template>
  <div class='sc-message--file' :style="fileStyle">
    <div class='sc-message--file-name'>
      <icon-file :color="fileStyle.color" />
      <a v-if="data.url"
         class='sc-message--file-name-text'
         :href="data.url"
         target='_blank'
         @click="handleFileDownload"
      >
        {{displayFileName}}
      </a>
      <span v-else class='sc-message--file-name-text'>{{displayFileName}}</span>
    </div>
  </div>
</template>

<script>
import IconFile from '../icons/icons/IconFile'
import { Event, EventBus } from '@/util/event-bus'

export default {
  components: {
    IconFile
  },

  props: {
    data: {
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    },
    direction: {
      type: String,
      required: true
    }
  },

  computed: {
    fileName () {
      if (this.data.file) return this.data.file.name

      if (this.data.url) {
        const urlParts = this.data.url.split('/')
        return urlParts[urlParts.length - 1]
      }

      return ''
    },
    displayFileName () {
      const maxLength = 18
      const name = this.fileName

      if (!name || name.length <= maxLength) return name

      const extensionIndex = name.lastIndexOf('.')
      const hasExtension = extensionIndex > 0 && extensionIndex < name.length - 1

      if (!hasExtension) return `${name.slice(0, maxLength - 3)}...`

      const extension = name.slice(extensionIndex)
      const reservedLength = extension.length + 3
      const minBaseLength = 3

      if (reservedLength >= maxLength - minBaseLength) {
        return `${name.slice(0, maxLength - 3)}...`
      }

      const baseLength = maxLength - reservedLength
      return `${name.slice(0, baseLength)}...${extension}`
    },
    fileStyle () {
      const colors = this.direction === 'sent' ? this.messageColors.sentMessage.file : this.messageColors.receivedMessage.file

      return {
        color: colors.text,
        backgroundColor: colors.bg,
        borderColor: colors.border,
        borderStyle: 'solid',
        borderWidth: '1px'
      }
    }
  },

  methods: {
    handleFileDownload () {
      if (this.data.url) {
        const fileExtension = this.data.url.split('.').pop().toLowerCase()
        EventBus.$emit(Event.FILE_OPEN, {
          type: 'file',
          url: this.data.url,
          name: this.fileName,
          extension: fileExtension,
          isOpenable: ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'svg', 'txt', 'html'].includes(fileExtension)
        })
      }
    }
  }
}
</script>

<style scoped>
.sc-message--file-name {
  display: flex;
  align-items: center;
  min-width: 0;
}

.sc-message--file-name-text {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
